import React from 'react';

export default function SecondarySchool() {
  return (
    <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9936 23.6359H23.564C23.6852 23.6359 23.7843 23.5368 23.7843 23.4156V9.55859H16.9936L14.9797 16.81L16.9936 23.6359Z"
        fill="#ABCDA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88101 23.6359H1.3106C1.18803 23.6359 1.08887 23.5368 1.08887 23.4156V9.55859H7.88101L9.75398 16.81L7.88101 23.6359Z"
        fill="#ABCDA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.08887 11.577H6.94968V23.6356H7.65928C7.78045 23.6356 7.88101 23.5365 7.88101 23.4154V10.6377H1.08887V11.577Z"
        fill="#85AC82"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88078 10.638H1.08863H0.488193C0.419351 10.638 0.364258 10.5815 0.364258 10.5127V9.23369C0.364258 9.16485 0.419351 9.1084 0.488193 9.1084H7.88078V10.638Z"
        fill="#6F6571"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99805 10.6379H7.8808V9.55857V9.1084H6.99805V9.55857V10.6379Z"
        fill="#5D5360"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88086 23.6356H16.9935V10.6376V6.20996H7.88086V10.6376V23.6356Z"
        fill="#ECEAEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.881 7.28962H16.9937H17.8048C17.8971 7.28962 17.9714 7.21529 17.9714 7.12167V5.60447C17.9714 5.51222 17.8971 5.43652 17.8048 5.43652H12.4367H7.06986C6.9776 5.43652 6.90186 5.51226 6.90186 5.60447V7.12167C6.90186 7.21529 6.9776 7.28962 7.06986 7.28962H7.881Z"
        fill="#6F6571"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4365 3.63507H15.6894C15.8505 3.63507 15.9827 3.50292 15.9827 3.34046V1.2409C15.9827 1.07843 15.8505 0.946289 15.6894 0.946289H12.4365V3.63507Z"
        fill="#EE7A9B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88086 8.19358H16.1439V23.6352H16.9936V10.6373V7.28906H7.88086V8.19358Z"
        fill="#DAD8DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9937 7.28962H17.8048C17.8971 7.28962 17.9715 7.21529 17.9715 7.12167V5.60447C17.9715 5.51222 17.8971 5.43652 17.8048 5.43652H15.9814C16.0737 5.43652 16.1494 5.51226 16.1494 5.60447V7.12167C16.1494 7.21393 16.0751 7.28962 15.9842 7.28962H16.9937Z"
        fill="#5D5360"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9937 11.577H22.8545V23.6356H23.5641C23.6853 23.6356 23.7844 23.5365 23.7844 23.4154V10.6377H16.9937V11.577Z"
        fill="#85AC82"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.19673 15.0492H4.51245V13.0254H6.19673C6.29175 13.0254 6.37026 13.1039 6.37026 13.1989V14.8758C6.37022 14.9708 6.29175 15.0492 6.19673 15.0492Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51235 15.0493H2.82944C2.73305 15.0493 2.65454 14.9708 2.65454 14.8758V13.1989C2.65454 13.1039 2.73305 13.0254 2.82944 13.0254H4.51235V15.0493Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51235 18.6932H2.82944C2.73305 18.6932 2.65454 18.6147 2.65454 18.5183V16.8428C2.65454 16.7464 2.73305 16.668 2.82944 16.668H4.51235V18.6932Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.19673 18.6932H4.51245V16.668H6.19673C6.29175 16.668 6.37026 16.7464 6.37026 16.8428V18.5183C6.37022 18.6147 6.29175 18.6932 6.19673 18.6932Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6778 15.0492H20.3607V13.0254H18.6778C18.5814 13.0254 18.5029 13.1039 18.5029 13.1989V14.8758C18.5029 14.9708 18.5814 15.0492 18.6778 15.0492Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3608 15.0493H22.0451C22.1401 15.0493 22.2187 14.9708 22.2187 14.8758V13.1989C22.2187 13.1039 22.1401 13.0254 22.0451 13.0254H20.3608V15.0493Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3608 18.6932H22.0451C22.1401 18.6932 22.2187 18.6147 22.2187 18.5183V16.8428C22.2187 16.7464 22.1401 16.668 22.0451 16.668H20.3608V18.6932Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6778 18.6932H20.3607V16.668H18.6778C18.5814 16.668 18.5029 16.7464 18.5029 16.8428V18.5183C18.5029 18.6147 18.5814 18.6932 18.6778 18.6932Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.24 22.021L12.4366 22.3611V17.0537H10.4989C10.357 17.0537 10.24 17.1693 10.24 17.3112V22.021Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4365 22.2639L14.6331 22.021V17.3112C14.6331 17.1693 14.5174 17.0537 14.3756 17.0537H12.4365V22.2639Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4366 14.3249C13.9184 14.3249 15.1193 13.1175 15.1193 11.6293C15.1193 10.141 13.9184 8.93359 12.4366 8.93359C10.9548 8.93359 9.75391 10.141 9.75391 11.6293C9.75391 13.1175 10.9548 14.3249 12.4366 14.3249Z"
        fill="#A9CADA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9937 10.638H23.7844H24.3849C24.4537 10.638 24.5102 10.5815 24.5102 10.5127V9.23369C24.5102 9.16485 24.4538 9.1084 24.3849 9.1084H16.9937V10.638Z"
        fill="#6F6571"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7844 10.638H24.3848C24.4537 10.638 24.5102 10.5815 24.5102 10.5127V9.23369C24.5102 9.16485 24.4537 9.1084 24.3848 9.1084H22.9485C23.016 9.1084 23.0724 9.16485 23.0724 9.23369V10.5127C23.0724 10.5815 23.016 10.638 22.9485 10.638H23.7844Z"
        fill="#5D5360"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55278 23.6355H15.3203V22.3372C15.3203 22.1637 15.1661 22.0205 14.9788 22.0205H14.6331H12.4365H10.2399H9.89563C9.70699 22.0205 9.55273 22.1637 9.55273 22.3372V23.6355H9.55278Z"
        fill="#ABCDA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.65454 17.6799H4.51235V16.668H2.82944C2.73305 16.668 2.65454 16.7464 2.65454 16.8415V17.6799Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.51245 17.6799H6.37022V16.8415C6.37022 16.7465 6.29171 16.668 6.19668 16.668H4.51245V17.6799Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5029 14.0373H20.3607V13.0254H18.6779C18.5815 13.0254 18.503 13.1039 18.503 13.1989V14.0373H18.5029Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3606 14.0373H22.2184V13.1989C22.2184 13.1039 22.1399 13.0254 22.0449 13.0254H20.3606V14.0373H20.3606Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5029 17.6799H20.3607V16.668H18.6779C18.5815 16.668 18.503 16.7464 18.503 16.8415V17.6799H18.5029Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3606 17.6799H22.2184V16.8415C22.2184 16.7465 22.1399 16.668 22.0449 16.668H20.3606V17.6799H20.3606Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.635 9.55861C13.1168 9.55861 14.3177 10.7646 14.3177 12.2529C14.3177 12.9358 14.0657 13.5595 13.6484 14.0345C14.5216 13.5898 15.1192 12.6797 15.1192 11.6293C15.1192 10.141 13.9184 8.93359 12.4365 8.93359C11.635 8.93359 10.9148 9.28742 10.4231 9.84778C10.7867 9.66326 11.1984 9.55861 11.635 9.55861Z"
        fill="#6DA6C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2449 23.6355H15.3204V22.3372C15.3204 22.1637 15.1662 22.0205 14.9789 22.0205H14.6332H13.9033C14.0906 22.0205 14.2449 22.1637 14.2449 22.3372V23.6355Z"
        fill="#85AC82"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5437 3.63507H15.6895C15.8506 3.63507 15.9828 3.50292 15.9828 3.34046V1.2409C15.9828 1.07843 15.8506 0.946289 15.6895 0.946289H14.5437C14.7062 0.946289 14.8384 1.07843 14.8384 1.2409V3.34046C14.8384 3.50292 14.7062 3.63507 14.5437 3.63507Z"
        fill="#C74368"
      />
      <path
        d="M13.2492 11.6213H12.801V10.6378C12.801 10.4366 12.6379 10.2734 12.4366 10.2734C12.2354 10.2734 12.0723 10.4366 12.0723 10.6378V11.9856C12.0723 12.1869 12.2354 12.35 12.4366 12.35H13.2492C13.4505 12.35 13.6136 12.1869 13.6136 11.9856C13.6136 11.7844 13.4505 11.6213 13.2492 11.6213Z"
        fill="#373737"
      />
      <path
        d="M12.4365 8.56934C10.7563 8.56934 9.3894 9.94205 9.3894 11.6294C9.3894 13.3167 10.7563 14.6894 12.4365 14.6894C14.1167 14.6894 15.4836 13.3167 15.4836 11.6294C15.4836 9.94205 14.1167 8.56934 12.4365 8.56934ZM12.4365 13.9607C11.1582 13.9607 10.1181 12.9149 10.1181 11.6294C10.1181 10.3439 11.1581 9.29808 12.4365 9.29808C13.7148 9.29808 14.7549 10.3439 14.7549 11.6294C14.7549 12.9149 13.7148 13.9607 12.4365 13.9607Z"
        fill="#373737"
      />
      <path
        d="M2.82955 15.4128H6.19674C6.4933 15.4128 6.73461 15.1715 6.73461 14.8749V13.198C6.73461 12.9015 6.4933 12.6602 6.19674 12.6602H2.82955C2.53223 12.6602 2.29028 12.9014 2.29028 13.198V14.8749C2.29033 15.1715 2.53223 15.4128 2.82955 15.4128ZM4.87684 13.389H6.00586V14.684H4.87684V13.389ZM3.01908 13.389H4.1481V14.684H3.01908V13.389Z"
        fill="#373737"
      />
      <path
        d="M2.29033 18.5184C2.29033 18.8157 2.53223 19.0576 2.8296 19.0576H6.19679C6.49334 19.0576 6.73466 18.8157 6.73466 18.5184V16.8429C6.73466 16.5456 6.49334 16.3037 6.19679 16.3037H2.82955C2.53223 16.3037 2.29028 16.5456 2.29028 16.8429V18.5184H2.29033ZM4.87684 17.0325H6.00586V18.3289H4.87684V17.0325ZM3.01908 17.0325H4.1481V18.3289H3.01908V17.0325Z"
        fill="#373737"
      />
      <path
        d="M18.6779 15.4128H22.0451C22.3417 15.4128 22.583 15.1715 22.583 14.8749V13.198C22.583 12.9015 22.3417 12.6602 22.0451 12.6602H18.6779C18.3806 12.6602 18.1387 12.9014 18.1387 13.198V14.8749C18.1387 15.1715 18.3806 15.4128 18.6779 15.4128ZM20.7252 13.389H21.8543V14.684H20.7252V13.389ZM18.8675 13.389H19.9965V14.684H18.8675V13.389Z"
        fill="#373737"
      />
      <path
        d="M18.6779 19.0576H22.0451C22.3417 19.0576 22.583 18.8157 22.583 18.5184V16.8429C22.583 16.5456 22.3417 16.3037 22.0451 16.3037H18.6779C18.3806 16.3037 18.1387 16.5456 18.1387 16.8429V18.5184C18.1387 18.8157 18.3806 19.0576 18.6779 19.0576ZM20.7252 17.0325H21.8543V18.3289H20.7252V17.0325ZM18.8675 17.0325H19.9965V18.3289H18.8675V17.0325Z"
        fill="#373737"
      />
      <path
        d="M24.3848 8.74377H17.3579V7.65381H17.8047C18.0975 7.65381 18.3357 7.41498 18.3357 7.12144V5.60424C18.3357 5.3107 18.0975 5.07192 17.8047 5.07192H12.8009V3.99994H15.6894C16.0521 3.99994 16.3471 3.70431 16.3471 3.34096V1.24134C16.3471 0.877992 16.0521 0.582364 15.6894 0.582364H12.8009V0.364372C12.8009 0.163142 12.6378 0 12.4365 0C12.2352 0 12.0721 0.163142 12.0721 0.364372V0.946737V3.63556V5.07197H7.0698C6.77626 5.07197 6.53742 5.3108 6.53742 5.60429V7.12149C6.53742 7.41503 6.77626 7.65386 7.0698 7.65386H7.51657V8.74382H0.488308C0.219061 8.74377 0 8.96342 0 9.23344V10.5124C0 10.7825 0.219061 11.0021 0.488308 11.0021H0.724372V15.8584C0.724372 16.0596 0.887466 16.2227 1.08874 16.2227C1.29002 16.2227 1.45312 16.0596 1.45312 15.8584V11.0021H7.51657V23.2713H1.45312V17.5407C1.45312 17.3395 1.29002 17.1764 1.08874 17.1764C0.887466 17.1764 0.724372 17.3395 0.724372 17.5407V23.4154C0.724372 23.7377 0.987304 24 1.31043 24H7.88089H16.9935H23.564C23.8864 24 24.1487 23.7377 24.1487 23.4154V11.0021H24.3847C24.6548 11.0021 24.8744 10.7824 24.8744 10.5124V9.23339C24.8745 8.96342 24.6548 8.74377 24.3848 8.74377ZM12.8009 1.31111H15.6184V3.27119H12.8009V1.31111ZM7.51657 10.2733H0.728745V9.47247H7.51657V10.2733ZM24.1457 9.47252V10.2734H23.7844H17.3579V9.47252H24.1457ZM14.956 23.2713H9.91715V22.3851H10.24H14.6331H14.956V23.2713H14.956ZM10.6044 21.6563V17.4177H12.0721V21.6563H10.6044ZM12.8009 21.6563V17.4177H14.2687V21.6563H12.8009ZM14.9975 21.6572V17.3108C14.9975 16.9679 14.7185 16.689 14.3756 16.689H10.4989C10.1552 16.689 9.87561 16.968 9.87561 17.3108V21.6573C9.49496 21.6676 9.18836 21.9684 9.18836 22.3373V23.2713H8.24526V10.6377V9.1081V7.65377H11.5496C11.7509 7.65377 11.914 7.49062 11.914 7.28939C11.914 7.08816 11.7509 6.92502 11.5496 6.92502H7.26612V5.80066H17.607V6.92502H13.172C12.9707 6.92502 12.8076 7.08816 12.8076 7.28939C12.8076 7.49062 12.9707 7.65377 13.172 7.65377H16.6292V23.2713H15.6847V22.3373C15.6847 21.9679 15.378 21.6669 14.9975 21.6572ZM23.42 23.2713H17.3579V11.0021H23.42V23.2713H23.42Z"
        fill="#373737"
      />
    </svg>
  );
}
